import { OnDestroy, Input, OnInit, Directive } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppInjector } from './core-services/app.injector';
import { ComponentConfig, PrefixLangs } from './core-services/core.models';

import { CoreService } from './core-services/core.service';
import { Jurisdication } from './core-services/visitor/visitor.model';

/*
 * ng 9+ needs decorator on abstract classes
 */
@Directive({})
export abstract class BaseComponent implements OnDestroy, OnInit {
  @Input() public jurisdiction: Jurisdication;
  @Input() public countryCode: string;
  @Input() public currency: string;
  @Input() public symbol: string;
  destroy$: Subject<void> = new Subject<void>();

  public coreService: CoreService;
  public translate: TranslateService;

  public config$: BehaviorSubject<ComponentConfig> = new BehaviorSubject<ComponentConfig>(undefined);
  public langChangeEvent$: Observable<LangChangeEvent>;

  private prefixLang: string;

  constructor(prefixLang?: PrefixLangs) {
    this.coreService = AppInjector.injector.get(CoreService);
    this.translate = AppInjector.injector.get(TranslateService);
    this.prefixLang = prefixLang;

    const currentLang: string = this.coreService.getCurrentLangFromCookie();

    if (currentLang && currentLang !== this.translate.currentLang) {
      this.translate.use(currentLang);
    } else if (this.translate.currentLang === undefined) {
      this.translate.use('en');
    }
  }

  public ngOnInit(): void {
    const langPrefix: string = this.coreService.getLangPrefix(this.jurisdiction, this.prefixLang);

    this.translate
      .get(langPrefix)
      .pipe(takeUntil(this.destroy$))
      .subscribe((value: ComponentConfig) => {
        this.config$.next(value);
      });
    this.translate.onLangChange.pipe(takeUntil(this.destroy$)).subscribe((event: LangChangeEvent) => {
      const newConfig: ComponentConfig = this.coreService.switchLangGetConfig(event, this.jurisdiction, this.prefixLang);

      this.config$.next(newConfig);
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
